module.exports = __webpack_public_path__ + "static/media/destaque-linhas.ce5c7b70.jpg";